import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { nrPageAction } from './util-helpers/newrelic';
import { AddInStorage } from './storage/AddInStorage';
import Wrapper from './Wrapper';

let LSAccess;

try {
  // test for LS access
  AddInStorage.getItem('userTenant');
  LSAccess = true;
} catch (error) {
  LSAccess = false;
  nrPageAction('outlookLoad', { message: `LS Access: ${error}` });
}

const MAX_RETRIES = 3;
const RETRY_INTERVAL = 1000; // 1 second

const initializeOffice = (retryCount = 0) => {
  if (!global.Office) {
    if (retryCount < MAX_RETRIES) {
      nrPageAction('outlookLoad', { message: `Retrying Office.js initialization (${retryCount + 1}/${MAX_RETRIES})` });
      setTimeout(() => initializeOffice(retryCount + 1), RETRY_INTERVAL);
      return;
    }
    nrPageAction('outlookLoad', { message: 'Office.js not found after maximum retries' });
    document.write('Error: Office.js is not available. Please ensure you are running this add-in in an Office application.');
    return;
  }

  // Initialize Office.js
  Office.onReady(() => {
    // must conditionally require the loader or the app crashes on LS access
    // eslint-disable-next-line
    const loadApp = require('./app-loader');

    // First render the Wrapper
    const container = document.getElementById('container');
    if (container) {
      ReactDOM.render(
        <Wrapper>
          <div id="app-content"></div>
        </Wrapper>,
        container
      );

      // Then let the app loader render into app-content
      loadApp.default();
    }
  }).catch(error => {
    if (retryCount < MAX_RETRIES) {
      nrPageAction('outlookLoad', { message: `Office.js initialization failed, retrying (${retryCount + 1}/${MAX_RETRIES}): ${error}` });
      setTimeout(() => initializeOffice(retryCount + 1), RETRY_INTERVAL);
    } else {
      nrPageAction('outlookLoad', { message: `Office.js initialization failed after ${MAX_RETRIES} retries: ${error}` });
      document.write('Error initializing Office.js. Please refresh the page.');
    }
  });
};

if (LSAccess) {
  initializeOffice();
} else {
  document.write(' There was an error with cookies or AddInStorage permissions. \n Please ensure they are enabled for this site and 3rd party-cookies.');
}
